/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx } from "react/jsx-runtime";
// Global
import { useComponentProps } from '@sitecore-content-sdk/nextjs';
import RelatedExpertCommentsWidget from 'widgets/RelatedExpertComments';
const RelatedExpertCommentsClient = (props)=>{
    // App Router + Content SDK 2.0: AppPlaceholder only forwards
    // { fields, params, rendering }, so the `getComponentServerProps` result
    // lives in ComponentPropsContext keyed by rendering UID. Read it back here
    // (with a fallback to inline props for the rare cases where the SDK does
    // forward them, e.g. design library / editor render paths).
    const ctxProps = useComponentProps(props?.rendering?.uid);
    const staticProps = props?.staticProps ?? ctxProps?.staticProps ?? {
        initialNews: [],
        fetchError: null
    };
    return /*#__PURE__*/ _jsx(RelatedExpertCommentsWidget, {
        params: props?.params,
        id: props?.params?.RenderingIdentifier,
        uid: props?.rendering?.uid,
        staticProps: staticProps
    });
};
export default RelatedExpertCommentsClient;
